import { ArgsType } from '@nestjs/graphql'
import { BaseDeleteDto } from '../base/baseDelete.dto'

@ArgsType()
export class DeleteBookDto extends BaseDeleteDto<DeleteBookDto> { }
